import React from 'react'
import propTypes from 'prop-types'
import { Field, useField} from 'formik'

import { SliderWithLabels, SliderInlineWithLabels, SliderFieldWithLabelsPropTypes } from '../Slider'

export const SliderFieldWithLabels = ({ name, ...rest }) => {
  const [field, meta, helpers] = useField(name)
  return (
    <Field
      {...rest}
      name={field.name}
      onChange={((_e, value) => helpers.setValue(value))}
      onBlur={(e) => helpers.setTouched(e)}
      component={SliderWithLabels}
    />
  )
}

export const SliderInlineFieldWithLabels = ({ name, ...rest }) => {
  const [field, meta, helpers] = useField(name)
  return (
    <Field
      {...rest}
      name={field.name}
      onChange={((_e, value) => helpers.setValue(value))}
      onBlur={(e) => helpers.setTouched(e)}
      component={SliderInlineWithLabels}
    />
  )
}

SliderFieldWithLabels.propTypes = {
  ...SliderFieldWithLabelsPropTypes,
}
